import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { transmitApplication } from 'src/app/store/actions/account.action';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-confirm-transmit',
  templateUrl: './confirm-transmit.component.html',
  styleUrls: ['./confirm-transmit.component.scss']
})
export class ConfirmTransmitComponent implements OnInit {

  data!: any;

  constructor(
    private modalService: ModalService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  dismiss(){
    this.modalService.hideConfirmTransmit();
  }

  transmit(){
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(transmitApplication({uuid: this.data.id}))
  }
}
